    /* =======================
       CATEGORIEPAGINA (ook swiper-cards): labels, voorraad
    ======================= */
    setTimeout(function () {
        var abCatProductCards = document.querySelectorAll("li.product-card");

        abCatProductCards.forEach(function(abCard) {
            var abLabelSpan = abCard.querySelector(".s1lb.label span");
            if (abLabelSpan) {
                abLabelSpan.style.fontSize = "16px";
                abLabelSpan.style.fontWeight = "bold";
                abLabelSpan.style.padding = "4px 8px";
                abLabelSpan.style.display = "inline-block";
            }

            var abVoorraadEl = abCard.querySelector("p.stock");
            if (abVoorraadEl) {
                var abVoorraadText = abVoorraadEl.textContent || "";
                var abVoorraadMatch = abVoorraadText.match(/Nog\s+(\d+)\s+op\s+voorraad/);
                if (abVoorraadMatch && parseInt(abVoorraadMatch[1], 10) > 50) {
                    abVoorraadEl.innerHTML = abVoorraadEl.innerHTML.replace(
                        /Nog\s+\d+\s+op\s+voorraad/,
                        "Nog ruim op voorraad"
                    );
                }
            }
        });
    }, 1000);

if (window.matchMedia("(min-width: 997px)").matches) {
    /* =======================
       PRODUCTPAGINA: voorraadtekst aanpassen + levertijd onder stock
    ======================= */
    var stockEl = document.querySelector("p.stock");
    var uspEl = document.querySelector("#main-product .metafield-rich_text_field");

    if (stockEl) {
        var stockText = stockEl.textContent || "";
        var voorraadMatch = stockText.match(/Nog\s+(\d+)\s+op\s+voorraad/);
        if (voorraadMatch && parseInt(voorraadMatch[1], 10) > 50) {
            stockEl.innerHTML = stockEl.innerHTML.replace(
                /Nog\s+\d+\s+op\s+voorraad/,
                "Nog ruim op voorraad"
            );
        }
    }

    /* =======================
       Korting + totaalprijs
    ======================= */
    var attempts = 0;
    var maxAttempts = 10;
    var interval = setInterval(function() {
        var kortingCel = document.querySelector(".discounty-volume-discount-widget__discount");
        var prijsEl = document.querySelector(".f8pr-price.s1pr.price");
        var qtyInput = document.querySelector("#quantity");

        if (kortingCel && prijsEl && qtyInput) {
            clearInterval(interval);

            var percText = kortingCel.textContent.trim();
            var percMatch = percText.match(/(\d+)%/);
            var prijsMatches = prijsEl.textContent.match(/€\s?(\d+,\d{2})/g);
            var basePrice = null;
            var prijsText = "";

            if (prijsMatches && prijsMatches.length > 0) {
                var prijzen = prijsMatches.map(function(p) {
                    return parseFloat(p.replace(/[^\d,]/g, "").replace(",", "."));
                });
                basePrice = Math.min.apply(null, prijzen);
                prijsText = "€" + basePrice.toFixed(2).replace(".", ",");
            }

            var perc = percMatch ? parseFloat(percMatch[1]) : null;

            var prijsContainer = document.createElement("div");
            prijsContainer.className = "ab-prijs-berekening";

            var submitContainer = document.querySelector(".submit.m10");
            if (submitContainer) {
                submitContainer.parentNode.insertBefore(prijsContainer, submitContainer);
            }

            var updatePrijs = function() {
                var aantal = parseInt(qtyInput.value, 10);
                if (!isNaN(aantal) && basePrice && aantal >= 2) {
                    var totaal = basePrice * aantal;
                    if (perc !== null) {
                        totaal = totaal * (1 - perc / 100);
                    }
                    prijsContainer.textContent = "Prijs: €" + totaal.toFixed(2).replace(".", ",") + " incl. korting";
                } else {
                    prijsContainer.textContent = "";
                }
            };

            qtyInput.addEventListener("input", updatePrijs);
            qtyInput.addEventListener("change", updatePrijs);

            var incr = document.querySelector(".incr");
            var decr = document.querySelector(".decr");
            if (incr) incr.addEventListener("click", function() { setTimeout(updatePrijs, 100); });
            if (decr) decr.addEventListener("click", function() { setTimeout(updatePrijs, 100); });

            updatePrijs();
        } else {
            attempts++;
            if (attempts >= maxAttempts) {
                clearInterval(interval);
            }
        }
    }, 500);
}